import { render } from "./Auth.vue?vue&type=template&id=3ccd0f4e"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"
script.render = render

export default script